import React from 'react';
import chartConfigs3, { third_chart_month } from './dashboard_third_chart';
import DashboardCost from './DashboardCost';
import chartConfigs4, { fourth_chart_month } from './DashboardAppliances';
import DashboardEmission from './DashboardEmission';
import DashboardUsers from './DashboardUsers';
import FusionCharts from 'fusioncharts';
import charts from 'fusioncharts/fusioncharts.charts';
import widgets from 'fusioncharts/fusioncharts.widgets';
import powercharts from 'fusioncharts/fusioncharts.powercharts';
import theme from 'fusioncharts/themes/fusioncharts.theme.ocean';
import ReactFC from 'react-fusioncharts';
import { connect } from 'react-redux';
import { withRouter } from '../../components/withRouter';
import { withAuth } from '../../components/withAuth';

charts(FusionCharts);
widgets(FusionCharts);
powercharts(FusionCharts);
theme(FusionCharts);

FusionCharts.options.creditLabel = false;

class Dashboard extends React.Component {

  componentDidUpdate() {
    if (this.props.options.id === 1) {
      FusionCharts.items['mychart3'].setJSONData(third_chart_month);
    }
  }

  /*componentDidUpdate() {
    if (this.props.options.id === 1) {
      FusionCharts.items['mychart1'].setJSONData(first_chart_month);
    }
  }*/
  componentDidUpdate() {
    if (this.props.options.id === 1) {
      FusionCharts.items['mychart4'].setJSONData(fourth_chart_month);
    }
  }
  /*
  componentDidUpdate() {
    if (this.props.options.id === 1) {
      FusionCharts.items['mychart6'].setJSONData(sixth_chart_month);
    }
  }
  */

  render() {
    return (
      <div
        id='content-body'
        className='col-12 col-md-9 col-xl-10 pl-4 pr-4 bd-content'
      >
        <div className='row'>
          <div className='col-md-12 pt-4 mt-3'>
            <h2>Dashboard</h2>
          </div>
          <div>           
          </div>
        </div>

        <div className='row mt-3 db-chart'>
         
          <div id='parent1' className='col-lg-6 col-xl-4'>
            <div className='chart-card mb-4'>
              <div className='chart-title' id='text1'>
                COST
              </div>
              <div id='chart1' className='chart'>
                <DashboardCost />
              </div>
            </div>
          </div>

          <div id='parent2' className='col-lg-6 col-xl-4'>
            <div className='chart-card mb-4'>
              <div className='chart-title' id='text6'>
                CARBON FOOTPRINT
              </div>
              <div id='chart2' className='chart'>
                <DashboardEmission/>
              </div>
            </div>
          </div>

          <div id='parent3' className='col-lg-6 col-xl-4'>
            <div className='chart-card mb-4'>
              <div className='chart-title' id='text3'>
                USAGE ESTIMATE
              </div>
              <div id='chart3' className='chart'>
                <ReactFC {...chartConfigs3} />
              </div>
            </div>
          </div>
          <div id='parent4' className='col-lg-6 col-xl-4'>
            <div className='chart-card mb-4'>
              <div className='chart-title' id='text4'>
                ACTIVE APPLIANCES
              </div>
              <div id='chart4' className='chart'>
                <ReactFC {...chartConfigs4} />
              </div>
            </div>
          </div>
          <div id='parent5' className='col-lg-12 col-xl-8'>
            <div className='chart-card mb-1'>
              <div className='chart-title' id='text5'>
               USER  MANAGEMENT
              </div>
              <div id='chart5' className='chart'>
               <DashboardUsers />
              </div>
            </div>
          </div>
          
        </div>

        {/* <!-- chart row end -->
            <!-- energy tip start --> */}
        <div className='row'>
          <div className='col-md-12 pb-3'>
            <span className='footer-text-1'>Energy Tip: </span>
            <span className='footer-text-2'>
             On all days, turning off or unplugging electrical devices when you're not at departments
             can help reduce your energy costs by approximately 10 percent.
            </span>
          </div>
        </div>

        {/* <!-- energy tip end --> */}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    options: state.options,
  };
}

const ConnectedDashboard = connect(mapStateToProps)(
  withAuth(withRouter(Dashboard))
);

export default ConnectedDashboard;
